<template>
  <el-dropdown @command="handleChange" trigger="click">
    <el-tooltip effect="dark" :content="item.label" placement="top">
      <div class="padding-5 pointer flex-center">
        <img :src="item.icon" :style="{ width: item.size + 'px', height: item.size + 'px' }" />
      </div>
    </el-tooltip>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in item.list" :key="item.value" :command="item.value">
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script >
const __sfc_main = {};
__sfc_main.props = {
  item: {
    type: Object,
    default: () => {}
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emits = __ctx.emit;
  const handleChange = e => {
    emits('setTableAlign', e);
  };
  return {
    handleChange
  };
};
export default __sfc_main;
</script>
<style scoped lang="scss"></style>
